/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LocationMapIcon16Light } from './LocationMapIcon16Light';
import { LocationMapIcon16Regular } from './LocationMapIcon16Regular';
import { LocationMapIcon16Solid } from './LocationMapIcon16Solid';
import { LocationMapIcon20Light } from './LocationMapIcon20Light';
import { LocationMapIcon20Regular } from './LocationMapIcon20Regular';
import { LocationMapIcon20Solid } from './LocationMapIcon20Solid';
import { LocationMapIcon24Regular } from './LocationMapIcon24Regular';
import { LocationMapIcon24Solid } from './LocationMapIcon24Solid';
import { LocationMapIcon32Regular } from './LocationMapIcon32Regular';
import { LocationMapIcon64Regular } from './LocationMapIcon64Regular';
var sizes = {
    16: {
        light: LocationMapIcon16Light,
        regular: LocationMapIcon16Regular,
        solid: LocationMapIcon16Solid,
    },
    20: {
        light: LocationMapIcon20Light,
        regular: LocationMapIcon20Regular,
        solid: LocationMapIcon20Solid,
    },
    24: {
        regular: LocationMapIcon24Regular,
        solid: LocationMapIcon24Solid,
    },
    32: {
        regular: LocationMapIcon32Regular,
    },
    64: {
        regular: LocationMapIcon64Regular,
    },
};
export var LocationMapIcon = forwardRef('LocationMapIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
